/**
 * 商城奖励服务
 * @returns
 */
import BaseServer from '@/domain/common/base.server.js';
import useMsgServer from '@/domain/common/msg.server.js';
import { mallRewardApi } from '@/request/index.js';

class MallRewardServer extends BaseServer {
  constructor() {
    if (typeof MallRewardServer.instance === 'object') {
      return MallRewardServer.instance;
    }
    super();

    this.state = {};

    MallRewardServer.instance = this;

    this.listenMsg()
    return this;
  }

  setState(key, value) {
    this.state[key] = value;
  }

  listenMsg() {
    // // 房间消息
    useMsgServer().$onMsg('ROOM_MSG', rawMsg => {
      let temp = Object.assign({}, rawMsg);

      if (typeof temp.data !== 'object') {
        temp.data = JSON.parse(temp.data);
        temp.context = JSON.parse(temp.context);
      }
      // console.log(temp, '原始消息');
      const { type = '' } = temp.data || {};
      switch (type) {
        // 商城奖励推送消息
        case 'mall_reward_push':
        // 商城奖励结束消息
        case 'mall_reward_end':
        // 直播结束
        case 'live_over':
          this.$emit(type, temp);
          break;
        default:
          break;
      }
    });
  }

  getValidList(params) {
    return mallRewardApi.getValidList(params);
  }
  receive(params) {
    return mallRewardApi.receive(params);
  }
}

export default function useMallRewardServer() {
  return new MallRewardServer();
}
